const termsAndConditions = {
  title1: 'AVISO LEGAL',
  content1: `<v-layout row wrap>
  <v-flex xs12>
    <ol style="text-align: justify">
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>COMPANY INFORMATION</u>
        </li>
        <p class="body-1">
          In compliance with Directive 2000/31/EC of the European Parliament and of the Council of 8
          June of the Information Society Services and Electronic Commerce, and of the Law
          Española, 34/2002, of 11 July,
          <b>GLOSPEN, SL</b> informs you that he owns the websites:
          <b>www.fbase.tv</b>, in accordance with the requirement of Article 10 of the aforementioned Act, GLOSPEN,
          SL, notifies the following data: the owner of this website is
          <b>GLOSPEN, SL</b> con NIF/CIF:
          <b>L713690W</b>. y social domicile:
          <b>CRTA DE LA PLANA, EDIF. MIRADOR PARC, BLOC- II 5º 2ª</b>,
          Postal code:
          <b>AD700</b>. Locality:
          <b>ESCALDES-ENGORDANY, PRINCIPALITY OF ANDORRA</b>. La
          company contact email address is:
          <b>
            <u>info@fbase.tv</u>
          </b>
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>USER AND LIABILITY REGIME</u>
        </li>
        <p class="body-1">
          Navigation by access or use of the website and all sub-domains and directories
          included under it, as well as the services or contents that through it can
          obtain and all own domain portals under the ownership of
          <b>GLOSPEN, SL</b>, grants the
          Condition of
          <b>User</b>, by which are accepted, when browsing the page
          <b>GLOSPEN, SL</b>, all
          the conditions of use set out here without prejudice to the application of the
          corresponding legally binding regulations as the case may be.
        </p>
        <p class="body-1">
          Therefore, if the considerations detailed in this legal notice are not to your satisfaction,
          please do not use the portal, as any use you make of it or the services and
          The inclusion of any information contained in this document implies the acceptance of the legal terms set out in this document.
          text.
        </p>
        <p class="body-1">
          The website of
          <b>GLOSPEN, SL</b> provides a wide range of information, services and
          data. The user assumes responsibility for the correct use of the websites. This
          responsibility will extend to: The veracity and legality of the information provided by the
          user in the forms issued by
          <b>GLOSPEN, SL</b> to access certain
          contents or services offered by the web.
        </p>
        <p class="body-1">
          The use of the information, services and data offered by
          <b>
            <b>GLOSPEN, SL</b>
          </b> they will not go against
          provisions of these conditions, the Law, morality, good manners or public order or that, in
          in any other case, they could imply injury to the rights of third parties or the operation of the sites
          web.
        </p>
        <p class = "body-1">
        The use of the information, services and data offered by
        <b> GLOSPEN, SL </b> will not go against them
        provisions of these conditions, the Law, morality, good manners or public order
        or that, in another case, could cause injury to the rights of third parties or operation
        of websites. To this end, the User will refrain from using any of the contents
        for purposes or illicit effects, prohibited in this text, infringing the rights and interests of
        third parties, or that in any way may damage, disable, overload, deteriorate or prevent the
        normal use of the contents, other Users or any Internet user
        (hardware and software).
        </p>
        <p class="body-1">
          Users will be liable for damages of any nature that the company
          owner of the website may suffer, directly or indirectly, as a result of
          breach of any of the obligations arising from the use of the Web and this policy
          Of privacy.
        </p>
        <p class="body-1">
          In particular, and merely indicative and not exhaustive, the User undertakes not to
          transmit, disseminate or make available to third parties information, data, content,
          messages, graphics, drawings, sound and / or image files, photographs from the web.
        </p>
      </div>
    </ol>
  </v-flex>
</v-layout>`,
  title2: 'PRIVACY POLICY',
  content2: `<v-layout row wrap>
  <v-flex xs12>
    <ol style="text-align: justify">
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>LINK POLICY AND LIABILITY EXEMPTIONS</u>
        </li>
        <p class = "body-1">
        <b> GLOSPEN, SL </b> is not responsible for the content of the web pages to which it may
        access the user through the links established on their websites and declares that in
        no case will examine or exercise any type of control over the content of other pages
        of the network.
        </p>
        <p class="body-1">
          It also does not guarantee technical availability, accuracy, veracity, validity or legality.
          from pages outside your property that can be accessed through the links.
        </p>
        <p class="body-1">
          <b>GLOSPEN, SL</b> declares that it has taken all necessary measures to avoid any
          damage that may arise from browsing your web pages. In consecuense,
          <b>GLOSPEN, SL</b> is not responsible, in any case, for any damages that may
          suffer the user because of Internet browsing.
        </p>
        <p class="body-1">
          <b>GLOSPEN, SL</b> is not responsible for damages or losses of any kind produced in
          the User who brings cause of failures or disconnections in telecommunications networks
          that cause the suspension, cancellation, installation or interruption of the web service
          during the provision of the same or prior.
        </p>
        <p class="body-1">
          Access to the web:
          <b>www.fbase.tv</b> does not imply the obligation on the part of the company to control
          the absence of viruses or any other harmful computer element. It corresponds to the User, in
          In any case, the availability of adequate tools for the detection and disinfection of
          harmful computer programs.
        </p>
        <p class="body-1">
          <b>GLOSPEN, SL</b> is not responsible for damage to computer equipment,
          documents and / or files of the Users or third parties during the provision of the service in the
          Portal.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>ADVERTISING</u>
        </li>

        <p class="body-1">
          The Web:
          <b>www.fbase.tv</b> You can host advertising or sponsored content. Advertisers or
          Sponsors are solely responsible for ensuring that the material submitted for their
          Inclusion on the web complies with the laws that in each case may be applicable.
        </p>
        <p class="body-1">
          <b>GLOSPEN, SL</b> will not be responsible for any errors, inaccuracies or irregularities that may
          Contain advertising or sponsor content.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>MODIFICATIONS</u>
        </li>
        <p class="body-1">
          <b>GLOSPEN, SL</b> reserves the right to make the modifications it deems appropriate,
          without prior notice, in the content of their websites, both in terms of the contents of the
          websites as per their conditions of use or by the general conditions of contract.
          Such modifications may be made, through their websites, in any way
          admissible in law and will be mandatory for as long as they are published
          on the web and until they are modified by subsequent ones.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>COOKIES RESERVATION</u>
        </li>
        <p class="body-1">
          <b>GLOSPEN, SL</b> reserves the right to use cookies in the user's navigation for their
          Websites to facilitate personalization and convenience of navigation. Following the policy
          of data protection of the company,
          <b>GLOSPEN, SL</b> informs that cookies are associated with
          anonymous user and your computer and do not provide the name or surname by themselves
          of the user.
        </p>
        <p class="body-1">
          The user has the possibility to configure his browser so that he is informed of the
          Receiving cookies, being able, if you wish, to prevent them from being installed on your hard drive. Without
          However, to access the websites of
          <b>GLOSPEN, SL</b> is not required to install
          cookies.
        </p>
        <p class="body-1">
          The user agrees to refrain from reproducing, copying, distributing, making available or
          in any other way publicly communicate, transform or modify the Contents, to
          unless authorised by the holder of the relevant rights or
          is legally permitted.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>PERSONAL DATA PROTECTION</u>
        </li>
        <p class="body-1">
          In accordance with the provisions of the EU-2016/679 General Rules of Procedure of the European Parliament and
          European Council for the Protection of Personal Data, adopted on 27 April
          2016,
          <b>GLOSPEN, SL</b> informs the users of its websites that we are obliged to
          keep professional secrecy about personal data collected by the company through
          forms placed on its pages, this obligation will continue even after
          our business or contractual relationship has ended, and under no circumstances may we make public
          the personal data of visitors and customers to the website without their consent.
          <b>
            Children under 14 years of age cannot give their consent for a shop to collect and process their
            individual data
          </b>; only their legal representatives (parents or guardians) can
          to do it on his behalf. Those businesses that need to process data from children under 14,
          must have the means to obtain the consent of their parents or guardians, by
          for example, by an e-mail message addressed to one of them containing a
          link to an electronic form. Children under 14 cannot be asked for data on the
          family environment, the only exception being the identification and contact details of the parents or
          tutors.
        </p>
        <p class="body-1">
          These data will be introduced in an automated file under the responsibility of the
          administrator of the website of,
          <b>GLOSPEN, SL</b> in order to be able to facilitate, speed up and fulfil
          the commitments established between the two parties. Also,
          <b>GLOSPEN, SL</b> reports on the
          ability to exercise the rights of
          <b>access</b>, that allows the web user to know what data
          The administrator of this page has the personal information and will answer within 30 days.
          days, as long as you keep the data,
          <b>Correction</b>, which allows you to correct errors, modify the
          data that are inaccurate or incomplete and ensure the accuracy of the information,
          <b>opposition</b>
          who may request and obtain that you do not carry out data processing,
          <b>deletion</b> that
          allows inappropriate or excessive data to be deleted,
          <b>limitation</b>, whereby you can
          request that the processing of your data be limited when you have exercised your right to
          rectification of your personal data, and
          <b>portability</b>, so that the user can obtain a
          copy of the personal data you have provided on the website in order to be able to transmit them to others
          services, these rights may be exercised by any means which leaves a record of their
          and its reception at the address:
          <b>
            CRTA DE LA PLANA, EDIF. MIRADOR PARC, BLOC-
            II 5º 2ª
          </b>. Zip code:
          <b>AD700</b>. Location:
          <b>
              SCALDING-FATTY. Province: PRINCIPALITY
            OF ANDORRA
          </b>. Email:
          <b>
            <u>Info@fbase.tv</u>
          </b>, by providing a photocopy of your ID card or
          alternative documentation proving your identity.
        </p>

        <p class="body-1">
          Until you inform us otherwise, we will understand that your data has not been modified,
          that you agree to notify us of any variation and that we have the consent
          to use them in order to build loyalty between the parties.
        </p>
        <p class="body-1">
          Sending your data through the form(s) on our website will be subject to
          you must have read/accepted the Privacy Policy, by means of a check box
          required at the bottom of the form.
        </p>
        <p class="body-1">
          In accordance with the provisions of Law 34/2002, of Services of the Company of the
          Information and Electronic Commerce in its article 21, we ask for your consent to
          to make advertising communications that we believe may be of interest to you, by mail
          electronic communication or by any other equivalent electronic means, this
          consent will be accepted or denied with a mandatory check box at the bottom of the form.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>INTELLECTUAL PROPERTY</u>
        </li>
        <p class="body-1">
          The intellectual and industrial property rights derived from all texts, images, as well as
          as well as the means and forms of presentation and assembly of its pages belong, by themselves
          themselves or as a transferee, to
          <b>GLOSPEN, SL</b>. They will be, therefore, works protected with property
          the Spanish legal system, and both the Spanish and international regulations may be applied to them.
          and the Community in this field, such as the international treaties on the subject
          and signed by Spain, Royal Legislative Decree 1/1996.
        </p>
        <p class="body-1">
          All rights reserved. In compliance with the Law on Intellectual Property
          expressly prohibits the reproduction, distribution, public communication and use of
          all or part of the contents of its web pages without the explicit consent of
          <b>GLOSPEN, SL</b>.
        </p>
        <p class="body-1">
          That's right,
          <b>GLOSPEN, SL</b> reserves the right to bring civil or criminal proceedings
          that it considers appropriate for the improper use of its web pages and contents or for the
          failure to comply with these conditions.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>TRUST MARKS</u>
        </li>
        <p class="body-1">
          Trustmarks are labels provided to online stores to demonstrate
          its quality and security in online sales.
        </p>
        <p class="body-1">
          To get the seal, they are audited or assessed for compliance with
          security criteria in the purchase and legal compliance in terms of privacy and protection
          of consumer data.
        </p>
        <p class="body-1">
          Stores with a trust mark adhere to a code of conduct and
          often provide consumers with alternative dispute resolution procedures
          simple, fast and comfortable.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>LSSI-CE COMPLIANCE AND DATA PROTECTION CERTIFICATES</u>
        </li>
        <p class="body-1">
          <b>www.fbase.tv</b> complies with the Data Protection regulations in force and
          <b>LSSI-CE</b>, and has
          has been advised on these regulations by
          <b>
            <a
              target="_blank"
              href="https://www.grupoqualia.net/es/inicio"
            >QUALIA GROUP</a>
          </b>, so he is given
          certificates in digital image format so you can display them on your website.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>LEGAL ACTIONS, APPLICABLE LAW AND JURISDICTION</u>
        </li>
        <p class="body-1">
          The relationship between the user and
          <b>GLOSPEN, SL</b> shall be governed by the European regulations in force and
          shall be competent to decide on any dispute that may arise between the user
          y
          <b>GLOSPEN, SL</b>, the courts in the town of
          <b>
            ESCALDES-ENGORDANY,
            PRINCIPALITY OF ANDORRA
          </b>.
        </p>
      </div>
    </ol>
  </v-flex>
</v-layout>`,
}
export default termsAndConditions
